var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEtrActivityLogIssuanceIssued(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.503906 7.00349C0.503906 3.41387 3.41387 0.503906 7.00349 0.503906C10.5931 0.503906 13.5031 3.41387 13.5031 7.00349C13.5031 10.5931 10.5931 13.5031 7.00349 13.5031C3.41387 13.5031 0.503906 10.5931 0.503906 7.00349ZM9.5302 6.0018C9.77096 5.66474 9.69289 5.19633 9.35583 4.95557C9.01877 4.71482 8.55036 4.79289 8.3096 5.12994L6.42854 7.76343L5.61718 6.95207C5.32428 6.65918 4.84941 6.65918 4.55652 6.95207C4.26362 7.24496 4.26362 7.71984 4.55652 8.01273L5.99391 9.45013C6.1498 9.60602 6.36639 9.68542 6.5861 9.66724C6.80582 9.64906 7.0064 9.53512 7.13454 9.35573L9.5302 6.0018Z",
    fill: "#0E7241"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEtrActivityLogIssuanceIssued);
export default __webpack_public_path__ + "static/media/etr-activity-log-issuance-issued.b976b3deb5deb16382081032f5670d29.svg";
export { ForwardRef as ReactComponent };